<nav #header class="fixed-top" style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerHeader" style="background-color: white;">
        <div class="logo">
            <a href="https://equator-expeditions.com/" target="_blank"><img src="../assets/images/logos-header/ee.svg"
                    class="" alt="" style="max-width: 200px; height: auto;" decoding="async"></a>

        </div>
        <div class="kontakt">
            <ul class="navbar-nav">
                <li class="nav-item menuItem"><a href="https://equator-expeditions.com/galapagos/"
                        target="_blank">GALAPAGOS</a>
                </li>
                <li class="nav-item menuItem"><a href="https://equator-expeditions.com/day-tours/"
                        target="_blank">HIGHLIGHT ECUADOR</a>
                </li>
                <li class="nav-item menuItem"><a href="https://equator-expeditions.com/tailor-made/"
                        target="_blank">TAILOR MADE</a>
                </li>
                <li class="nav-item menuItem"><a href="https://equator-expeditions.com/why-us/" target="_blank">WHY
                        US</a>
                </li>
                <li class="nav-item menuItem"><a href="https://equator-expeditions.com/blog" target="_blank">BLOG</a>
                </li>
                <li class="nav-item menuItem"><a href="https://equator-expeditions.com/contact-us/"
                        target="_blank">CONTACT US</a>
                </li>
                <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
                    <app-heart-header></app-heart-header>
                </li>
            </ul>
        </div>
        <div class="header-telephone">
            <a class="rightButton" style="display: flex; align-items: center;"
                href="https://calendly.com/equator-expeditions-info/60min" target="_blank"><span
                    style="padding-right: 5px;">📞</span>Request
                a
                Call</a>
            <a class="langButton" style="display: flex; align-items: center;" href="https://equator-expeditions.com/"
                target="_blank">
                <img src="../../../../../../../../assets/images/es.svg" style="padding: 0 10px;" height="20px">
                ES
                <i class="fa fa-angle-down" style="padding-left: 5px;"></i>
            </a>
        </div>
        <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
    </div>
    <ul class="navbar-nav verticalMenu" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://equator-expeditions.com/galapagos/" target="_blank">GALAPAGOS</a>
        </li>
        <li class="nav-item menuItem"><a href="https://equator-expeditions.com/day-tours/" target="_blank">HIGHLIGHT
                ECUADOR</a>
        </li>
        <li class="nav-item menuItem"><a href="https://equator-expeditions.com/tailor-made/" target="_blank">TAILOR
                MADE</a>
        </li>
        <li class="nav-item menuItem"><a href="https://equator-expeditions.com/why-us/" target="_blank">WHY
                US</a>
        </li>
        <li class="nav-item menuItem"><a href="https://equator-expeditions.com/blog" target="_blank">BLOG</a>
        </li>
        <li class="nav-item menuItem"><a href="https://equator-expeditions.com/contact-us/" target="_blank">CONTACT
                US</a>
        </li>
        <li class="nav-item menuItem" *ngIf="companyParamsService.getFiltersInterest()">
            <app-heart-header></app-heart-header>
        </li>
    </ul>
</nav>